import React from 'react'
import classnames from 'classnames'
import styles from './Dropdown.module.css'
import { default as generalStyle } from '../Theme/GeneralTheme.module.css'

import { Checkbox } from '../Checkbox'
import { Label } from '../Label'
import { MdWarning, MdCancel } from 'react-icons/md'

const Dropdown = ({ ...props }) => {

  const { className, ...rest } = props;
  const childrenClassNames = classnames(styles.dropdown, className)

  return (
    <div className={childrenClassNames} {...rest}>
      {props.children}
    </div>
  )
}

const DropdownMenu = ({
  itens,
  activeItem,
  visible = false,
  up = false,
  borderSolid = false,
  smallPadding = false,
  ...props
}) => {

  const getStatus = (checkbox) => {
    return checkbox.status === 'invalid' ? true : false
  }

  const { className, ...rest } = props;
  const childrenClassNames = classnames([
    generalStyle.general_style,
    styles.dropdown_menu,
    up ? styles.dropdown_menu_up : '',
    borderSolid && styles.dropdown_menu_border_solid,
    smallPadding && styles.dropdown_menu_small_padding,
    visible ? styles.dropdown_menu_visible : '',
    styles.dropdown_menu_one_level,
  ], className)

  return (
    <ul
      className={childrenClassNames}
      {...rest}
    >
      {itens &&
        itens.map(({ group_label, label, handler, subItems, disabled, checkbox, ...props }, index) => {
          return (
            <li
              key={index}
              onClick={checkbox?.onChange ?? handler}
              className={classnames(
                disabled && styles.dropdown_menu_group_disabled,
                activeItem === index && styles.dropdown_menu_group_active,
                group_label && styles.dropdown_menu_group
              )}
              {...props}
            >
              {!!checkbox ? (
                <div className={classnames(styles.dropdown_menu_checkbox)}>
                  <Checkbox
                    checked={checkbox.checked}
                    onChange={() => undefined}
                    invalid={getStatus(checkbox)}
                  />
                  <div
                    className={classnames(styles.dropdown_menu_checkbox_label)}
                  >
                    <Label>{label}</Label>
                  </div>

                  {checkbox.status === 'warning' && (
                    <i className={classnames(styles.warning_icon)}>
                      <MdWarning />
                    </i>
                  )}
                  {checkbox.status === 'invalid' && (
                    <i className={classnames(styles.invalid_icon)}>
                      <MdCancel />
                    </i>
                  )}
                </div>
              ) : (
                <div>{label}</div>
              )}
            </li>
          )
        })}
    </ul>
  )
}

export { Dropdown, DropdownMenu }
